import React, { useState } from "react";
import Notiofication from "../../../components/Modal/Notification";
import HelpModal from "../../../components/Modal/HelpModal";
import Select from "react-select";

function Kitchen() {
  const deals = [
    { id: 1, deal: "Deal 1", qty: 1, status: "Ready", selected: false },
    { id: 2, deal: "Deal 2", qty: 1, status: "Ready", selected: false },
    { id: 3, deal: "Deal 3", qty: 1, status: "Ready", selected: false },
  ];
  const [selectedDeals, setSelectedDeals] = useState([]);

  const handleToggleSelect = (dealId) => {
    if (selectedDeals.includes(dealId)) {
      setSelectedDeals(selectedDeals.filter((id) => id !== dealId));
    } else {
      setSelectedDeals([...selectedDeals, dealId]);
    }
  };

  const handleSelectAll = () => {
    const allDealIds = deals.map((deal) => deal.id);
    setSelectedDeals(allDealIds);
  };

  const handleUnselectAll = () => {
    setSelectedDeals([]);
  };
  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between py-3">
          <div>
            <h1 className="text-[#7B20C7] text-2xl">Kitchen</h1>
          </div>
          <div className="flex gap-3">
            <div>
              <Select
                type="text"
                placeholder="Select Item"
                className="   placeholder-blueGray-300 text-blueGray-600 relative rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                required
              />
            </div>

            <Notiofication />
            <HelpModal />
          </div>
        </div>

        <div className="w-64 h-96 border border-[#7B20C7] bg-white border-dashed m-4 rounded-md relative">
          <div className="w-full bg-[#7B20C7] text-white p-2 text-sm flex justify-between">
            <div>
              <span>
                <h5>Invoice: A 000351</h5>
                <h5>Table: None</h5>
              </span>
            </div>
            <div>
              <span className="bg-yellow-100 text-yellow-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded">
                10:04
              </span>
            </div>
          </div>
          <div className="flex flex-col justify-between h-80">
            <div className="p-2 text-sm h-64 overflow-y-auto">
              {deals.map((deal) => (
                <div
                  key={deal.id}
                  className={`w-full flex justify-between my-2 p-2 relative ${
                    selectedDeals.includes(deal.id) ? "bg-blue-100" : ""
                  }`}
                >
                  <div>
                    <span>
                      <h5>Deal: {deal.id}</h5>
                      <h5 className="font-medium">QTY: {deal.quantity}</h5>
                    </span>
                  </div>
                  <div>
                    <span className="bg-green-100 text-green-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded">
                      Ready
                    </span>
                  </div>
                  <div className="absolute top-0 left-0 w-full h-full">
                    <input
                      type="checkbox"
                      name=""
                      id={deal.id}
                      className="w-full h-full opacity-0"
                      onClick={() => handleToggleSelect(deal.id)}
                      checked={selectedDeals.includes(deal.id)}
                    />
                  </div>
                </div>
              ))}
            </div>
            <div className="p-2 text-xs relative left-0 border-t flex gap-2">
              <button onClick={handleSelectAll}>Select All</button>
              <button onClick={handleUnselectAll}>Unselect All</button>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Kitchen;
